import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, catchError, shareReplay } from 'rxjs/operators';
import { environment } from 'environments/environment';

// The Maps API key is intentionally embedded in the build artifact.
// Restrict it in the Google Cloud Console to HTTP referrers (production domain)
// and to the Maps JavaScript API only, so it cannot be abused outside the browser context.
@Injectable({ providedIn: 'root' })
export class MapsLoaderService {
  private load$: Observable<boolean> | null = null;
  private readonly http = inject(HttpClient);

  load(): Observable<boolean> {
    if ((window as any).google?.maps) {
      return of(true);
    }
    this.load$ = null;
    this.load$ = this.http
      .jsonp(
        `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}&libraries=drawing&v=3.64`,
        'callback',
      )
      .pipe(
        map(() => true),
        catchError(() => of(false)),
        shareReplay(1),
      );
    return this.load$;
  }
}
